const ResetarSenha = () => {

    return (
        <div>ResetarSenha</div>
    );
}

export default ResetarSenha;